import React, { useState } from "react";
import Body from "./Body";

const Teachers = () => {
  const [addMemberModal, setAddMemberModal] = useState(false);
  const _this = { addMemberModal, setAddMemberModal };
  return <Body {..._this} />;
};

export default Teachers;
